/**
 * Generated by orval 🍺
 * Do not edit manually.
 * AdminPanel v2
 * AP methods
 * OpenAPI spec version: 2.0
 */
import { customInstance } from './axios-instance.js';
import type { BodyType } from './axios-instance.js';
export interface AuthRequestBodyDto {
  /** @minLength 1 */
  login: string;
  /** @minLength 1 */
  password: string;
}

export interface AuthResponseDto {
  success: boolean;
  token?: string;
  error?: string;
}

export type AuthCheckDtoRole = typeof AuthCheckDtoRole[keyof typeof AuthCheckDtoRole];


export const AuthCheckDtoRole = {
  admin: 'admin',
  support: 'support',
} as const;

export interface AuthCheckDto {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  id: string;
  role: AuthCheckDtoRole;
}

export interface AuthTgBodyDto {
  id?: string;
  first_name?: string;
  last_name?: string;
  username?: string;
  auth_date?: string;
  hash?: string;
}

export interface AuthTgResponseDto {
  success: boolean;
  token?: string;
  error?: string;
}

export interface AuthLogoutDto {
  success: boolean;
  error?: string;
}

export type MailingsListResponseDtoRowsItemStatus = typeof MailingsListResponseDtoRowsItemStatus[keyof typeof MailingsListResponseDtoRowsItemStatus];


export const MailingsListResponseDtoRowsItemStatus = {
  new: 'new',
  pending: 'pending',
  sending: 'sending',
  finished: 'finished',
  error: 'error',
} as const;

export type MailingsListResponseDtoRowsItemGroup = typeof MailingsListResponseDtoRowsItemGroup[keyof typeof MailingsListResponseDtoRowsItemGroup];


export const MailingsListResponseDtoRowsItemGroup = {
  users: 'users',
  subscribers: 'subscribers',
  publicGroup: 'publicGroup',
} as const;

export type MailingsListResponseDtoRowsItemGroupOptions = {
  subscription?: boolean;
  traffic?: boolean;
  userActivity?: boolean;
};

export type MailingsListResponseDtoRowsItemReplyMarkupItem = {
  url?: string;
  text?: string;
  callback_data?: string;
};

export type MailingsListResponseDtoRowsItem = {
  id: number;
  name: string;
  status: MailingsListResponseDtoRowsItemStatus;
  group: MailingsListResponseDtoRowsItemGroup;
  groupOptions?: MailingsListResponseDtoRowsItemGroupOptions;
  text: string;
  image?: string;
  replyMarkup: MailingsListResponseDtoRowsItemReplyMarkupItem[];
  sent: boolean;
  createdAt: string;
  sendingStartedAt?: string;
  sentAt?: string;
  pinned?: boolean;
  recipientsCount: number;
  sentCount: number;
  errorsCount: number;
};

export interface MailingsListResponseDto {
  rows: MailingsListResponseDtoRowsItem[];
  total: number;
}

export type MailingsRecipientsResponseDtoRowsItem = {
  id: number;
  mailingId: number;
  userId: number;
  userUuid?: string;
  tgMessageId?: number;
  sentAt?: string;
  error?: string;
};

export interface MailingsRecipientsResponseDto {
  rows: MailingsRecipientsResponseDtoRowsItem[];
  total: number;
}

export type MailingCreateBodyDtoGroup = typeof MailingCreateBodyDtoGroup[keyof typeof MailingCreateBodyDtoGroup];


export const MailingCreateBodyDtoGroup = {
  users: 'users',
  subscribers: 'subscribers',
  publicGroup: 'publicGroup',
} as const;

export type MailingCreateBodyDtoReplyMarkupItem = {
  url?: string;
  text?: string;
  callback_data?: string;
};

export type MailingCreateBodyDtoGroupOptionsSubscription = typeof MailingCreateBodyDtoGroupOptionsSubscription[keyof typeof MailingCreateBodyDtoGroupOptionsSubscription];


export const MailingCreateBodyDtoGroupOptionsSubscription = {
  null: 'null',
  true: 'true',
  false: 'false',
} as const;

export type MailingCreateBodyDtoGroupOptionsTraffic = typeof MailingCreateBodyDtoGroupOptionsTraffic[keyof typeof MailingCreateBodyDtoGroupOptionsTraffic];


export const MailingCreateBodyDtoGroupOptionsTraffic = {
  null: 'null',
  true: 'true',
  false: 'false',
} as const;

export type MailingCreateBodyDtoGroupOptionsUserActivity = typeof MailingCreateBodyDtoGroupOptionsUserActivity[keyof typeof MailingCreateBodyDtoGroupOptionsUserActivity];


export const MailingCreateBodyDtoGroupOptionsUserActivity = {
  null: 'null',
  true: 'true',
  false: 'false',
} as const;

export type MailingCreateBodyDtoGroupOptions = {
  subscription?: MailingCreateBodyDtoGroupOptionsSubscription;
  traffic?: MailingCreateBodyDtoGroupOptionsTraffic;
  userActivity?: MailingCreateBodyDtoGroupOptionsUserActivity;
};

export interface MailingCreateBodyDto {
  name: string;
  text: string;
  group: MailingCreateBodyDtoGroup;
  replyMarkup: MailingCreateBodyDtoReplyMarkupItem[];
  pinned?: boolean;
  fileList?: string[];
  groupOptions?: MailingCreateBodyDtoGroupOptions;
}

export type MailingCreateResponseDtoMailingStatus = typeof MailingCreateResponseDtoMailingStatus[keyof typeof MailingCreateResponseDtoMailingStatus];


export const MailingCreateResponseDtoMailingStatus = {
  new: 'new',
  pending: 'pending',
  sending: 'sending',
  finished: 'finished',
  error: 'error',
} as const;

export type MailingCreateResponseDtoMailingGroup = typeof MailingCreateResponseDtoMailingGroup[keyof typeof MailingCreateResponseDtoMailingGroup];


export const MailingCreateResponseDtoMailingGroup = {
  users: 'users',
  subscribers: 'subscribers',
  publicGroup: 'publicGroup',
} as const;

export type MailingCreateResponseDtoMailingGroupOptions = {
  subscription?: boolean;
  traffic?: boolean;
  userActivity?: boolean;
};

export type MailingCreateResponseDtoMailingReplyMarkupItem = {
  url?: string;
  text?: string;
  callback_data?: string;
};

export type MailingCreateResponseDtoMailing = {
  id: number;
  name: string;
  status: MailingCreateResponseDtoMailingStatus;
  group: MailingCreateResponseDtoMailingGroup;
  groupOptions?: MailingCreateResponseDtoMailingGroupOptions;
  text: string;
  image?: string;
  replyMarkup: MailingCreateResponseDtoMailingReplyMarkupItem[];
  sent: boolean;
  createdAt: string;
  sendingStartedAt?: string;
  sentAt?: string;
  pinned?: boolean;
};

export interface MailingCreateResponseDto {
  success: boolean;
  error?: string;
  mailing?: MailingCreateResponseDtoMailing;
}

export type MailingInfoResponseDtoMailingStatus = typeof MailingInfoResponseDtoMailingStatus[keyof typeof MailingInfoResponseDtoMailingStatus];


export const MailingInfoResponseDtoMailingStatus = {
  new: 'new',
  pending: 'pending',
  sending: 'sending',
  finished: 'finished',
  error: 'error',
} as const;

export type MailingInfoResponseDtoMailingGroup = typeof MailingInfoResponseDtoMailingGroup[keyof typeof MailingInfoResponseDtoMailingGroup];


export const MailingInfoResponseDtoMailingGroup = {
  users: 'users',
  subscribers: 'subscribers',
  publicGroup: 'publicGroup',
} as const;

export type MailingInfoResponseDtoMailingGroupOptions = {
  subscription?: boolean;
  traffic?: boolean;
  userActivity?: boolean;
};

export type MailingInfoResponseDtoMailing = {
  id: number;
  name: string;
  status: MailingInfoResponseDtoMailingStatus;
  group: MailingInfoResponseDtoMailingGroup;
  text: string;
  groupOptions?: MailingInfoResponseDtoMailingGroupOptions;
  image?: string;
  replyMarkup: unknown[];
  sent: boolean;
  createdAt: string;
  sendingStartedAt: string;
  sentAt: string;
  pinned?: boolean;
};

export interface MailingInfoResponseDto {
  success: boolean;
  error?: string;
  mailing?: MailingInfoResponseDtoMailing;
}

export interface MailingTestMessageBodyDto {
  toTestGroup: boolean;
}

export interface MailingTestMessageResponseDto {
  success: boolean;
}

export interface MailingStartResponseDto {
  success: boolean;
}

export interface MailingDeleteResponseDto {
  success: boolean;
}

export type ResponseDtoDataItemCurrency = typeof ResponseDtoDataItemCurrency[keyof typeof ResponseDtoDataItemCurrency];


export const ResponseDtoDataItemCurrency = {
  rub: 'rub',
  usd: 'usd',
} as const;

export type ResponseDtoDataItem = {
  /** Provider name */
  providerName: string;
  /** Balance */
  balance: number;
  currency: ResponseDtoDataItemCurrency;
};

export interface ResponseDto {
  data: ResponseDtoDataItem[];
}

export type SupportHistoryResponseDtoMessagesItem = {
  messageId: number;
  from: number;
  fromName: string;
  to: number;
  isAnswer: boolean;
  text: string;
  date: string;
  photoFileId?: string;
};

export interface SupportHistoryResponseDto {
  messages: SupportHistoryResponseDtoMessagesItem[];
  total: number;
}

export interface SupportInfoResponseDto {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  uuid?: string;
  subID?: number;
  expire?: string;
  status?: string;
  app?: string;
  tag?: string;
  subUpd?: string;
  online?: boolean;
  lastConnectedServer?: string;
  lastConnectedAt?: string;
  personalRateLimit?: number;
}

export interface SupportGetPhotoResponseDto {
  photo?: string;
}

export type SupportChatsResponseDtoChatsItem = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  uuid: string;
  clientId: number;
  lastMessageAt: string;
  isAnswer: boolean;
  isAutoAnswer: boolean;
  message: string;
};

export interface SupportChatsResponseDto {
  chats: SupportChatsResponseDtoChatsItem[];
}

export interface SupportAnswerBodyDto {
  to: number;
  message: string;
}

export interface SupportAnswerResponseDto {
  success: boolean;
  error?: string;
}

export interface SupportCloseConversationResponseDto {
  success: boolean;
}

export type SupportSearchResponseDtoFoundItem = {
  from: number;
  to: number;
  isAnswer: boolean;
  messageId: number;
  message: string;
  date: string;
};

export interface SupportSearchResponseDto {
  found: SupportSearchResponseDtoFoundItem[];
  total: number;
}

export type StatsBaseResponseDtoStats = {
  notPayedActive: number;
  payedActive: number;
  increase: number;
  payedExpire: number;
  expireTodayPaid: number;
  expireTodayTrial: number;
  usersNew: number;
  usersNewWeb: number;
  usersNewHapp: number;
  totalPaymentsReceived: number;
  todayPaymentsReceived: number;
  todayPaymentsCount: number;
  firstPaymentCount: number;
  currentMonthPaymentsReceived: number;
  currentMonthPaymentsForecast: number;
  quarterPaymentsReceived: number;
  usersUnsubscribed: number;
  usersTotal: number;
};

export interface StatsBaseResponseDto {
  stats: StatsBaseResponseDtoStats;
}

export type StatsSubscriptionsResponseDtoDataItem = {
  tariff: number;
  count: number;
};

export interface StatsSubscriptionsResponseDto {
  data: StatsSubscriptionsResponseDtoDataItem[];
}

export type StatsChartPaymentsByHoursResponseDtoDataItem = {
  hour: number;
  count: number;
};

export interface StatsChartPaymentsByHoursResponseDto {
  data: StatsChartPaymentsByHoursResponseDtoDataItem[];
}

export type StatsChartDataResponseDtoDataItem = {
  interval: string;
  value: number;
  count?: number;
};

export interface StatsChartDataResponseDto {
  data: StatsChartDataResponseDtoDataItem[];
}

export type StatsChartDailyDataResponseDtoDataItem = {
  interval: string;
  payments: number;
  starts: number;
  registrations: number;
  paymentsSum: number;
  payedActive: number;
  payedExpire: number;
  notPayedActive: number;
  firstPaymentCount: number;
  increase: number;
  decrease: number;
  demoDiff: number;
};

export interface StatsChartDailyDataResponseDto {
  data: StatsChartDailyDataResponseDtoDataItem[];
}

export type StatsSupportResponseDtoDataItem = {
  interval: string;
  value: number;
  autoAnswers: number;
};

export interface StatsSupportResponseDto {
  data: StatsSupportResponseDtoDataItem[];
  today: number;
}

export type StatsReferralsResponseDtoDataItemUser = {
  tgUserId: string;
  tgUserFirstName: string;
  tgUserLastName: string;
  tgUserName: string;
  invitingRefId: string;
  subscribed: boolean;
};

export type StatsReferralsResponseDtoDataItem = {
  referralId: string;
  subscriptions: number;
  registrations: number;
  paidSubscriptions: number;
  referredPayments: number;
  referredPaymentCount: number;
  user: StatsReferralsResponseDtoDataItemUser;
};

export interface StatsReferralsResponseDto {
  data: StatsReferralsResponseDtoDataItem[];
  total: number;
}

export type UsersListResponseDtoRowsItem = {
  uuid: string;
  tgUserId: string;
  key: string;
  keyId: string;
  active: boolean;
  demoActivated: boolean;
  demoActivatedAt: string;
  demoReActivated: boolean;
  demoReActivatedAt: string;
  subscribed: boolean;
  subscribedAt: string;
  subscriptionPayedAt: string;
  subscriptionPayedTo: string;
  paymentAmount: number;
  paymentTerm: number;
  createdAt: string;
  deletedAt: string;
  tgUserName: string;
  tgUserPhone: string;
  tgUserFirstName: string;
  tgUserLastName: string;
  server: string;
  promoCode: string;
  tvCode: string;
  tvCodeExpireAt: string;
  invitingRefId: string;
  refId: string;
  refAccrued: boolean;
  unsubscribed: boolean;
  mailingExpiredCount: number;
  remnaUserId: number;
  remnaUuid: string;
  remnaSubscription: string;
  remnaConnected: boolean;
  remnaActivated: boolean;
  remnaMigrated: boolean;
  torrentBlockCount: number;
  ip: string;
  isConnected: boolean;
  personalPaymentRate: number;
  email: string;
  isSupportChatBanned: boolean;
  lastOnline: string;
  trafficDown: number;
  trafficUp: number;
  trafficDownFmt: string;
  trafficUpFmt: string;
};

export interface UsersListResponseDto {
  rows: UsersListResponseDtoRowsItem[];
  total: number;
}

export interface UsersUpdateSubscriptionBodyDto {
  expiration: string;
}

export interface UsersUpdateSubscriptionResponseDto {
  success: boolean;
}

export interface UsersRenewSubscriptionUrlResponseDto {
  success: boolean;
}

export type UserGetResponseDtoUser = {
  uuid: string;
  tgUserId: string;
  key: string;
  keyId: string;
  active: boolean;
  demoActivated: boolean;
  demoActivatedAt: string;
  demoReActivated: boolean;
  demoReActivatedAt: string;
  subscribed: boolean;
  subscribedAt: string;
  subscriptionPayedAt: string;
  subscriptionPayedTo: string;
  paymentAmount: number;
  paymentTerm: number;
  createdAt: string;
  deletedAt: string;
  tgUserName: string;
  tgUserPhone: string;
  tgUserFirstName: string;
  tgUserLastName: string;
  server: string;
  promoCode: string;
  tvCode: string;
  tvCodeExpireAt: string;
  invitingRefId: string;
  refId: string;
  refAccrued: boolean;
  unsubscribed: boolean;
  mailingExpiredCount: number;
  remnaUserId: number;
  remnaUuid: string;
  remnaSubscription: string;
  remnaConnected: boolean;
  remnaActivated: boolean;
  remnaMigrated: boolean;
  torrentBlockCount: number;
  ip: string;
  isConnected: boolean;
  personalPaymentRate: number;
  email: string;
  isSupportChatBanned: boolean;
};

export type UserGetResponseDtoStats = {
  userUuid?: string;
  lastOnline?: string;
  trafficUp?: number;
  trafficDown?: number;
  online?: boolean;
};

export interface UserGetResponseDto {
  user: UserGetResponseDtoUser;
  stats: UserGetResponseDtoStats;
}

export interface UserDirectMessageBodyDto {
  text: string;
  markup: unknown[];
}

export interface UserDirectMessageResponseDto {
  success: boolean;
}

export interface UserDeleteResponseDto {
  success: boolean;
}

export interface UserBanByDevicesLimitResponseDto {
  success: boolean;
}

export type UsersMergeBodyDtoMergePropsItem = typeof UsersMergeBodyDtoMergePropsItem[keyof typeof UsersMergeBodyDtoMergePropsItem];


export const UsersMergeBodyDtoMergePropsItem = {
  email: 'email',
  tgUserId: 'tgUserId',
} as const;

export type UsersMergeBodyDtoMergeExpirationType = typeof UsersMergeBodyDtoMergeExpirationType[keyof typeof UsersMergeBodyDtoMergeExpirationType];


export const UsersMergeBodyDtoMergeExpirationType = {
  transferLastPayment: 'transferLastPayment',
  usePrimaryExpirationDate: 'usePrimaryExpirationDate',
  useMergedExpirationDate: 'useMergedExpirationDate',
  customExpirationDate: 'customExpirationDate',
} as const;

export interface UsersMergeBodyDto {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  from: string;
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  to: string;
  mergeProps: UsersMergeBodyDtoMergePropsItem[];
  mergeExpirationType: UsersMergeBodyDtoMergeExpirationType;
  customExpirationDate?: string;
}

export interface UsersMergeResponseDto {
  success: boolean;
}

export type UsersTransferBodyDtoUnit = typeof UsersTransferBodyDtoUnit[keyof typeof UsersTransferBodyDtoUnit];


export const UsersTransferBodyDtoUnit = {
  day: 'day',
  month: 'month',
} as const;

export interface UsersTransferBodyDto {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  from: string;
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  to: string;
  value: number;
  unit: UsersTransferBodyDtoUnit;
}

export interface UsersTransferResponseDto {
  success: boolean;
  error?: string;
}

export type PaymentsListResponseDtoRowsItemUser = {
  tgUserId: string;
  email: string;
  subscriptionPayedTo: string;
  subscriptionPayedAt: string;
  personalPaymentRate: number;
};

export type PaymentsListResponseDtoRowsItemPaymentOrderPaymentType = typeof PaymentsListResponseDtoRowsItemPaymentOrderPaymentType[keyof typeof PaymentsListResponseDtoRowsItemPaymentOrderPaymentType];


export const PaymentsListResponseDtoRowsItemPaymentOrderPaymentType = {
  sbp: 'sbp',
  bank_card: 'bank_card',
  sberbank: 'sberbank',
  tinkoff_bank: 'tinkoff_bank',
  crypto: 'crypto',
  stars: 'stars',
} as const;

export type PaymentsListResponseDtoRowsItemPaymentOrderMerchant = typeof PaymentsListResponseDtoRowsItemPaymentOrderMerchant[keyof typeof PaymentsListResponseDtoRowsItemPaymentOrderMerchant];


export const PaymentsListResponseDtoRowsItemPaymentOrderMerchant = {
  telegram: 'telegram',
  cryptoBot: 'cryptoBot',
  yookassa: 'yookassa',
  morune: 'morune',
  enot: 'enot',
} as const;

export type PaymentsListResponseDtoRowsItemPaymentOrder = {
  merchantOrderId?: string;
  paymentType: PaymentsListResponseDtoRowsItemPaymentOrderPaymentType;
  merchant: PaymentsListResponseDtoRowsItemPaymentOrderMerchant;
  createdAt: string;
};

export type PaymentsListResponseDtoRowsItem = {
  id: number;
  userUuid: string;
  tariff: number;
  payedAmount: number;
  orderAmount: number;
  telegramPaymentChargeId: string;
  deletedAt: string;
  orderId: string;
  createdAt: string;
  user: PaymentsListResponseDtoRowsItemUser;
  paymentOrder: PaymentsListResponseDtoRowsItemPaymentOrder;
};

export interface PaymentsListResponseDto {
  rows: PaymentsListResponseDtoRowsItem[];
  total: number;
}

export type SubscribersListResponseDtoRowsItem = {
  id: number;
  tgUserId: number;
  tgUserName: string;
  tgUserPhone: string;
  tgUserFirstName: string;
  tgUserLastName: string;
  createdAt: string;
  unsubscribed: boolean;
  shortUuid: string;
};

export interface SubscribersListResponseDto {
  rows: SubscribersListResponseDtoRowsItem[];
  total: number;
}

export type RefLinksListResponseDtoRowsItem = {
  id: number;
  name: string;
  referralId: string;
  accrualBonus: boolean;
  bonus: number;
  expenses: number;
  createdAt: string;
  subscribers?: number;
  registrations?: number;
  paid?: number;
  active?: number;
  withTraffic?: number;
  paidAmount?: number;
};

export interface RefLinksListResponseDto {
  rows: RefLinksListResponseDtoRowsItem[];
  total: number;
}

export interface RefLinksCreateBodyDto {
  name: string;
  referralId: string;
  accrualBonus?: boolean;
  bonus?: number;
  expenses?: number;
}

export interface RefLinksCreateResponseDto {
  success: boolean;
}

export interface RefLinksDeleteResponseDto {
  success: boolean;
  error?: string;
}

export type PromoCodesListResponseDtoRowsItem = {
  id: string;
  code: string;
  bonusDays: number;
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  userId?: string;
  revoked: boolean;
  expireAt?: string;
  newOnly: boolean;
  maxUses?: number;
  description?: string;
  createdAt: string;
};

export interface PromoCodesListResponseDto {
  rows: PromoCodesListResponseDtoRowsItem[];
  total: number;
}

export interface PromoCodeGenerateResponseDto {
  success: boolean;
  error?: string;
  code?: string;
}

export interface PromoCodesCreateBodyDto {
  code: string;
  bonusDays: number;
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  userId?: string;
  newOnly: boolean;
  maxUses?: number;
  description?: string;
  expireAt?: string;
}

export type PromoCodesCreateResponseDtoPromoCode = {
  id: string;
  code: string;
  bonusDays: number;
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  userId?: string;
  revoked: boolean;
  expireAt?: string;
  newOnly: boolean;
  maxUses?: number;
  description?: string;
  createdAt: string;
};

export interface PromoCodesCreateResponseDto {
  success: boolean;
  error?: string;
  promoCode?: PromoCodesCreateResponseDtoPromoCode;
}

export interface PromoCodeDeleteResponseDto {
  success: boolean;
  error?: string;
}

export type PromoCodeGetResponseDtoPromoCodeUsesItem = {
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  id: string;
  promoCodeId: string;
  userUuid: string;
  createdAt: string;
};

export type PromoCodeGetResponseDtoPromoCode = {
  id: string;
  code: string;
  bonusDays: number;
  /** @pattern ^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$ */
  userId?: string;
  revoked: boolean;
  expireAt?: string;
  newOnly: boolean;
  maxUses?: number;
  description?: string;
  createdAt: string;
  uses: PromoCodeGetResponseDtoPromoCodeUsesItem[];
};

export interface PromoCodeGetResponseDto {
  success: boolean;
  error?: string;
  promoCode?: PromoCodeGetResponseDtoPromoCode;
}

export type BannersListResponseDtoRowsItemActionType = typeof BannersListResponseDtoRowsItemActionType[keyof typeof BannersListResponseDtoRowsItemActionType];


export const BannersListResponseDtoRowsItemActionType = {
  internalLink: 'internalLink',
} as const;

export type BannersListResponseDtoRowsItemAction = {
  type: BannersListResponseDtoRowsItemActionType;
  link: string;
  text: string;
};

export type BannersListResponseDtoRowsItem = {
  id: number;
  enabled: boolean;
  title: string;
  text: string;
  image?: string;
  action?: BannersListResponseDtoRowsItemAction;
  createdAt: string;
  updatedAt: string;
  expireAt?: string;
  viewed: number;
};

export interface BannersListResponseDto {
  rows: BannersListResponseDtoRowsItem[];
  total: number;
}

export type AuthControllerSignIn500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type AuthControllerCheck500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type AuthControllerTgAuth500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type AuthControllerLogout500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type MailingsControllerListParams = {
/**
 * @minimum 1
 * @maximum 9999
 */
page?: number;
/**
 * @minimum 1
 * @maximum 999
 */
limit?: number;
sort?: string;
direction?: MailingsControllerListDirection;
};

export type MailingsControllerListDirection = typeof MailingsControllerListDirection[keyof typeof MailingsControllerListDirection];


export const MailingsControllerListDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type MailingsControllerList500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type MailingsControllerCreate500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type MailingsControllerRecipientsParams = {
/**
 * @minimum 1
 * @maximum 9999
 */
page?: number;
/**
 * @minimum 1
 * @maximum 999
 */
limit?: number;
sort?: string;
direction?: MailingsControllerRecipientsDirection;
};

export type MailingsControllerRecipientsDirection = typeof MailingsControllerRecipientsDirection[keyof typeof MailingsControllerRecipientsDirection];


export const MailingsControllerRecipientsDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type MailingsControllerRecipients500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type MailingsControllerGet500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type MailingsControllerDelete500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type MailingsControllerSendTestMessage500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type MailingsControllerStart500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type ServersBillingControllerGetList500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type SupportControllerHistoryParams = {
uid: number;
};

export type SupportControllerHistory500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type SupportControllerInfoParams = {
uid: number;
};

export type SupportControllerInfo500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type SupportControllerGetPhoto500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type SupportControllerChatsParams = {
limit: number;
offset: number;
};

export type SupportControllerChats500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type SupportControllerAnswer500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type SupportControllerCloseConversationParams = {
uid: number;
};

export type SupportControllerCloseConversation500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type SupportControllerSearchParams = {
/**
 * @minLength 1
 */
query: string;
};

export type SupportControllerSearch500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type StatsControllerBaseStats500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type StatsControllerSubscriptionsStats500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type StatsControllerChartPaymentsByHoursParams = {
from: string;
to: string;
};

export type StatsControllerChartPaymentsByHours500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type StatsControllerChartDataParams = {
type: StatsControllerChartDataType;
groupBy: StatsControllerChartDataGroupBy;
value?: StatsControllerChartDataValue;
from: string;
to: string;
};

export type StatsControllerChartDataType = typeof StatsControllerChartDataType[keyof typeof StatsControllerChartDataType];


export const StatsControllerChartDataType = {
  users: 'users',
  payments: 'payments',
} as const;

export type StatsControllerChartDataGroupBy = typeof StatsControllerChartDataGroupBy[keyof typeof StatsControllerChartDataGroupBy];


export const StatsControllerChartDataGroupBy = {
  day: 'day',
  week: 'week',
  month: 'month',
} as const;

export type StatsControllerChartDataValue = typeof StatsControllerChartDataValue[keyof typeof StatsControllerChartDataValue];


export const StatsControllerChartDataValue = {
  amount: 'amount',
  count: 'count',
} as const;

export type StatsControllerChartData500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type StatsControllerChartDailyDataParams = {
from: string;
to: string;
groupBy: StatsControllerChartDailyDataGroupBy;
};

export type StatsControllerChartDailyDataGroupBy = typeof StatsControllerChartDailyDataGroupBy[keyof typeof StatsControllerChartDailyDataGroupBy];


export const StatsControllerChartDailyDataGroupBy = {
  day: 'day',
  week: 'week',
  month: 'month',
} as const;

export type StatsControllerChartDailyData500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type StatsControllerSupportParams = {
from: string;
to: string;
groupBy: StatsControllerSupportGroupBy;
};

export type StatsControllerSupportGroupBy = typeof StatsControllerSupportGroupBy[keyof typeof StatsControllerSupportGroupBy];


export const StatsControllerSupportGroupBy = {
  day: 'day',
  week: 'week',
  month: 'month',
} as const;

export type StatsControllerSupport500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type StatsControllerReferralsParams = {
sort: string;
direction: StatsControllerReferralsDirection;
};

export type StatsControllerReferralsDirection = typeof StatsControllerReferralsDirection[keyof typeof StatsControllerReferralsDirection];


export const StatsControllerReferralsDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type StatsControllerReferrals500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type UsersControllerListParams = {
page?: number;
limit?: number;
sort?: string;
direction?: UsersControllerListDirection;
search?: string;
filter?: UsersControllerListFilter;
unsubscribed?: boolean;
all?: boolean;
hasTrafficOnly?: boolean;
active?: boolean;
inactive?: boolean;
paid?: boolean;
notpaid?: boolean;
};

export type UsersControllerListDirection = typeof UsersControllerListDirection[keyof typeof UsersControllerListDirection];


export const UsersControllerListDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type UsersControllerListFilter = typeof UsersControllerListFilter[keyof typeof UsersControllerListFilter];


export const UsersControllerListFilter = {
  online: 'online',
  new: 'new',
  inactive: 'inactive',
  unsubscribed: 'unsubscribed',
  active: 'active',
  subscribed: 'subscribed',
  zeroTraffic: 'zeroTraffic',
  remnaActivated: 'remnaActivated',
} as const;

export type UsersControllerList500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type UsersControllerUpdateSubscription500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type UsersControllerRenewSubscriptionUrl500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type UsersControllerUserGet500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type UsersControllerDeleteUser500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type UsersControllerBanSupportChat500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type UsersControllerUnbanSupportChat500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type UsersControllerDirectMessage500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type UsersControllerBanByDevicesLimit500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type UsersControllerMerge500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type UsersControllerTransfer500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type PaymentsControllerListParams = {
/**
 * @minimum 1
 * @maximum 9999
 */
page?: number;
/**
 * @minimum 1
 * @maximum 999
 */
limit?: number;
sort?: string;
direction?: PaymentsControllerListDirection;
search?: string;
};

export type PaymentsControllerListDirection = typeof PaymentsControllerListDirection[keyof typeof PaymentsControllerListDirection];


export const PaymentsControllerListDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type PaymentsControllerList500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type RemnaControllerNetworkMap500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type SubscribersControllerListParams = {
limit: number;
page: number;
search?: string;
sort?: string;
direction?: SubscribersControllerListDirection;
};

export type SubscribersControllerListDirection = typeof SubscribersControllerListDirection[keyof typeof SubscribersControllerListDirection];


export const SubscribersControllerListDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type SubscribersControllerList500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type RefLinksControllerListParams = {
limit: number;
page: number;
search?: string;
sort?: string;
direction?: RefLinksControllerListDirection;
};

export type RefLinksControllerListDirection = typeof RefLinksControllerListDirection[keyof typeof RefLinksControllerListDirection];


export const RefLinksControllerListDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type RefLinksControllerList500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type RefLinksControllerCreate500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type RefLinksControllerDelete500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type PromoCodesControllerListParams = {
/**
 * @minimum 1
 * @maximum 9999
 */
page?: number;
/**
 * @minimum 1
 * @maximum 999
 */
limit?: number;
sort?: string;
direction?: PromoCodesControllerListDirection;
search?: string;
};

export type PromoCodesControllerListDirection = typeof PromoCodesControllerListDirection[keyof typeof PromoCodesControllerListDirection];


export const PromoCodesControllerListDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type PromoCodesControllerList500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type PromoCodesControllerCreate500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type PromoCodesControllerGenerate500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type PromoCodesControllerDelete500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type PromoCodesControllerGet500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

export type BannerControllerList500 = {
  timestamp?: string;
  path?: string;
  message?: string;
  errorCode?: string;
};

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Authentication
 * @summary Authentication
 */
export const authControllerSignIn = (
    authRequestBodyDto: BodyType<AuthRequestBodyDto>,
 options?: SecondParameter<typeof customInstance<AuthResponseDto>>,) => {
      return customInstance<AuthResponseDto>(
      {url: `/api/v2/auth/sign-in`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: authRequestBodyDto
    },
      options);
    }

/**
 * Check authentication
 * @summary Check authentication
 */
export const authControllerCheck = (

 options?: SecondParameter<typeof customInstance<AuthCheckDto>>,) => {
      return customInstance<AuthCheckDto>(
      {url: `/api/v2/auth/status`, method: 'GET'
    },
      options);
    }

/**
 * Авторизация через Telegram
 * @summary Авторизация через Telegram
 */
export const authControllerTgAuth = (
    authTgBodyDto: BodyType<AuthTgBodyDto>,
 options?: SecondParameter<typeof customInstance<AuthTgResponseDto>>,) => {
      return customInstance<AuthTgResponseDto>(
      {url: `/api/v2/auth/tg-auth`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: authTgBodyDto
    },
      options);
    }

/**
 * Logout
 * @summary Logout
 */
export const authControllerLogout = (

 options?: SecondParameter<typeof customInstance<AuthLogoutDto>>,) => {
      return customInstance<AuthLogoutDto>(
      {url: `/api/v2/auth/logout`, method: 'POST'
    },
      options);
    }

/**
 * Список рассылок
 * @summary Список рассылок
 */
export const mailingsControllerList = (
    params?: MailingsControllerListParams,
 options?: SecondParameter<typeof customInstance<MailingsListResponseDto>>,) => {
      return customInstance<MailingsListResponseDto>(
      {url: `/api/v2/mailings`, method: 'GET',
        params
    },
      options);
    }

/**
 * Create mailing
 * @summary Create mailing
 */
export const mailingsControllerCreate = (
    mailingCreateBodyDto: BodyType<MailingCreateBodyDto>,
 options?: SecondParameter<typeof customInstance<MailingCreateResponseDto>>,) => {
      return customInstance<MailingCreateResponseDto>(
      {url: `/api/v2/mailings`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: mailingCreateBodyDto
    },
      options);
    }

/**
 * Get mailing recipients
 * @summary Get mailing recipients
 */
export const mailingsControllerRecipients = (
    mailingId: number,
    params?: MailingsControllerRecipientsParams,
 options?: SecondParameter<typeof customInstance<MailingsRecipientsResponseDto>>,) => {
      return customInstance<MailingsRecipientsResponseDto>(
      {url: `/api/v2/mailings/${mailingId}/recipients`, method: 'GET',
        params
    },
      options);
    }

/**
 * Get mailing info
 * @summary Get mailing info
 */
export const mailingsControllerGet = (
    mailingId: number,
 options?: SecondParameter<typeof customInstance<MailingInfoResponseDto>>,) => {
      return customInstance<MailingInfoResponseDto>(
      {url: `/api/v2/mailings/${mailingId}`, method: 'GET'
    },
      options);
    }

/**
 * Remove mailing
 * @summary Remove mailing
 */
export const mailingsControllerDelete = (
    mailingId: number,
 options?: SecondParameter<typeof customInstance<MailingDeleteResponseDto>>,) => {
      return customInstance<MailingDeleteResponseDto>(
      {url: `/api/v2/mailings/${mailingId}`, method: 'DELETE'
    },
      options);
    }

/**
 * Test mailing message
 * @summary Test mailing message
 */
export const mailingsControllerSendTestMessage = (
    mailingId: number,
    mailingTestMessageBodyDto: BodyType<MailingTestMessageBodyDto>,
 options?: SecondParameter<typeof customInstance<MailingTestMessageResponseDto>>,) => {
      return customInstance<MailingTestMessageResponseDto>(
      {url: `/api/v2/mailings/${mailingId}/test`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: mailingTestMessageBodyDto
    },
      options);
    }

/**
 * Start mailing
 * @summary Start mailing
 */
export const mailingsControllerStart = (
    mailingId: number,
 options?: SecondParameter<typeof customInstance<MailingStartResponseDto>>,) => {
      return customInstance<MailingStartResponseDto>(
      {url: `/api/v2/mailings/${mailingId}/start`, method: 'POST'
    },
      options);
    }

/**
 * List of all endpoints
 * @summary List of all endpoints
 */
export const serversBillingControllerGetList = (

 options?: SecondParameter<typeof customInstance<ResponseDto>>,) => {
      return customInstance<ResponseDto>(
      {url: `/api/v2/servers-billing/list`, method: 'POST'
    },
      options);
    }

/**
 * List of all endpoints
 * @summary List of all endpoints
 */
export const supportControllerHistory = (
    params: SupportControllerHistoryParams,
 options?: SecondParameter<typeof customInstance<SupportHistoryResponseDto>>,) => {
      return customInstance<SupportHistoryResponseDto>(
      {url: `/api/v2/support/history`, method: 'GET',
        params
    },
      options);
    }

/**
 * List of all endpoints
 * @summary List of all endpoints
 */
export const supportControllerInfo = (
    params: SupportControllerInfoParams,
 options?: SecondParameter<typeof customInstance<SupportInfoResponseDto>>,) => {
      return customInstance<SupportInfoResponseDto>(
      {url: `/api/v2/support/info`, method: 'GET',
        params
    },
      options);
    }

/**
 * Get photo
 * @summary Get photo
 */
export const supportControllerGetPhoto = (
    fileId: string,
 options?: SecondParameter<typeof customInstance<SupportGetPhotoResponseDto>>,) => {
      return customInstance<SupportGetPhotoResponseDto>(
      {url: `/api/v2/support/photo/${fileId}`, method: 'GET'
    },
      options);
    }

/**
 * List of chats
 * @summary List of chats
 */
export const supportControllerChats = (
    params: SupportControllerChatsParams,
 options?: SecondParameter<typeof customInstance<SupportChatsResponseDto>>,) => {
      return customInstance<SupportChatsResponseDto>(
      {url: `/api/v2/support/chats`, method: 'GET',
        params
    },
      options);
    }

/**
 * Answer to client
 * @summary Answer to client
 */
export const supportControllerAnswer = (
    supportAnswerBodyDto: BodyType<SupportAnswerBodyDto>,
 options?: SecondParameter<typeof customInstance<SupportAnswerResponseDto>>,) => {
      return customInstance<SupportAnswerResponseDto>(
      {url: `/api/v2/support/answer`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: supportAnswerBodyDto
    },
      options);
    }

/**
 * Close conversation
 * @summary Close conversation
 */
export const supportControllerCloseConversation = (
    params: SupportControllerCloseConversationParams,
 options?: SecondParameter<typeof customInstance<SupportCloseConversationResponseDto>>,) => {
      return customInstance<SupportCloseConversationResponseDto>(
      {url: `/api/v2/support/close`, method: 'GET',
        params
    },
      options);
    }

/**
 * Search
 * @summary Search
 */
export const supportControllerSearch = (
    params: SupportControllerSearchParams,
 options?: SecondParameter<typeof customInstance<SupportSearchResponseDto>>,) => {
      return customInstance<SupportSearchResponseDto>(
      {url: `/api/v2/support/search`, method: 'GET',
        params
    },
      options);
    }

/**
 * Основные показатели
 * @summary Основные показатели
 */
export const statsControllerBaseStats = (

 options?: SecondParameter<typeof customInstance<StatsBaseResponseDto>>,) => {
      return customInstance<StatsBaseResponseDto>(
      {url: `/api/v2/stats`, method: 'GET'
    },
      options);
    }

/**
 * Группировка подписок по тарифу
 * @summary Группировка подписок по тарифу
 */
export const statsControllerSubscriptionsStats = (

 options?: SecondParameter<typeof customInstance<StatsSubscriptionsResponseDto>>,) => {
      return customInstance<StatsSubscriptionsResponseDto>(
      {url: `/api/v2/stats/subscriptions`, method: 'GET'
    },
      options);
    }

/**
 * График оплат по часам
 * @summary График оплат по часам
 */
export const statsControllerChartPaymentsByHours = (
    params: StatsControllerChartPaymentsByHoursParams,
 options?: SecondParameter<typeof customInstance<StatsChartPaymentsByHoursResponseDto>>,) => {
      return customInstance<StatsChartPaymentsByHoursResponseDto>(
      {url: `/api/v2/stats/chart-payments-by-hours`, method: 'GET',
        params
    },
      options);
    }

/**
 * Графики статистики
 * @summary Графики статистики
 */
export const statsControllerChartData = (
    params: StatsControllerChartDataParams,
 options?: SecondParameter<typeof customInstance<StatsChartDataResponseDto>>,) => {
      return customInstance<StatsChartDataResponseDto>(
      {url: `/api/v2/stats/chart-data`, method: 'GET',
        params
    },
      options);
    }

/**
 * Графики ежедневной статистики
 * @summary Графики ежедневной статистики
 */
export const statsControllerChartDailyData = (
    params: StatsControllerChartDailyDataParams,
 options?: SecondParameter<typeof customInstance<StatsChartDailyDataResponseDto>>,) => {
      return customInstance<StatsChartDailyDataResponseDto>(
      {url: `/api/v2/stats/chart-daily-data`, method: 'GET',
        params
    },
      options);
    }

/**
 * Обращения в поддержку
 * @summary Обращения в поддержку
 */
export const statsControllerSupport = (
    params: StatsControllerSupportParams,
 options?: SecondParameter<typeof customInstance<StatsSupportResponseDto>>,) => {
      return customInstance<StatsSupportResponseDto>(
      {url: `/api/v2/stats/support`, method: 'GET',
        params
    },
      options);
    }

/**
 * Статистика по рефералам
 * @summary Статистика по рефералам
 */
export const statsControllerReferrals = (
    params: StatsControllerReferralsParams,
 options?: SecondParameter<typeof customInstance<StatsReferralsResponseDto>>,) => {
      return customInstance<StatsReferralsResponseDto>(
      {url: `/api/v2/stats/referrals`, method: 'GET',
        params
    },
      options);
    }

/**
 * Список пользователей
 * @summary Список пользователей
 */
export const usersControllerList = (
    params?: UsersControllerListParams,
 options?: SecondParameter<typeof customInstance<UsersListResponseDto>>,) => {
      return customInstance<UsersListResponseDto>(
      {url: `/api/v2/users`, method: 'GET',
        params
    },
      options);
    }

/**
 * Обновление подписки пользователя
 * @summary Обновление подписки пользователя
 */
export const usersControllerUpdateSubscription = (
    userUuid: string,
    usersUpdateSubscriptionBodyDto: BodyType<UsersUpdateSubscriptionBodyDto>,
 options?: SecondParameter<typeof customInstance<UsersUpdateSubscriptionResponseDto>>,) => {
      return customInstance<UsersUpdateSubscriptionResponseDto>(
      {url: `/api/v2/users/${userUuid}/subscription`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: usersUpdateSubscriptionBodyDto
    },
      options);
    }

/**
 * Перевыпуск ключа подписки
 * @summary Перевыпуск ключа подписки
 */
export const usersControllerRenewSubscriptionUrl = (
    userUuid: string,
 options?: SecondParameter<typeof customInstance<UsersRenewSubscriptionUrlResponseDto>>,) => {
      return customInstance<UsersRenewSubscriptionUrlResponseDto>(
      {url: `/api/v2/users/${userUuid}/subscription/renew`, method: 'POST'
    },
      options);
    }

/**
 * Информация о пользователе
 * @summary Информация о пользователе
 */
export const usersControllerUserGet = (
    userUuid: string,
 options?: SecondParameter<typeof customInstance<UserGetResponseDto>>,) => {
      return customInstance<UserGetResponseDto>(
      {url: `/api/v2/users/${userUuid}`, method: 'GET'
    },
      options);
    }

/**
 * Удаление пользователя
 * @summary Удаление пользователя
 */
export const usersControllerDeleteUser = (
    userUuid: string,
 options?: SecondParameter<typeof customInstance<UserDeleteResponseDto>>,) => {
      return customInstance<UserDeleteResponseDto>(
      {url: `/api/v2/users/${userUuid}`, method: 'DELETE'
    },
      options);
    }

/**
 * Блокировка чата поддержки
 * @summary Блокировка чата поддержки
 */
export const usersControllerBanSupportChat = (
    userUuid: string,
 options?: SecondParameter<typeof customInstance<UserGetResponseDto>>,) => {
      return customInstance<UserGetResponseDto>(
      {url: `/api/v2/users/${userUuid}/support/ban`, method: 'POST'
    },
      options);
    }

/**
 * Разблокировка чата поддержки
 * @summary Разблокировка чата поддержки
 */
export const usersControllerUnbanSupportChat = (
    userUuid: string,
 options?: SecondParameter<typeof customInstance<UserGetResponseDto>>,) => {
      return customInstance<UserGetResponseDto>(
      {url: `/api/v2/users/${userUuid}/support/unban`, method: 'POST'
    },
      options);
    }

/**
 * отправка сообщения в Телеграм
 * @summary отправка сообщения в Телеграм
 */
export const usersControllerDirectMessage = (
    userUuid: string,
    userDirectMessageBodyDto: BodyType<UserDirectMessageBodyDto>,
 options?: SecondParameter<typeof customInstance<UserDirectMessageResponseDto>>,) => {
      return customInstance<UserDirectMessageResponseDto>(
      {url: `/api/v2/users/${userUuid}/direct-message`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userDirectMessageBodyDto
    },
      options);
    }

/**
 * Блокировка пользователя за превышение лимита устройств
 * @summary Блокировка пользователя за превышение лимита устройств
 */
export const usersControllerBanByDevicesLimit = (
    userUuid: string,
 options?: SecondParameter<typeof customInstance<UserBanByDevicesLimitResponseDto>>,) => {
      return customInstance<UserBanByDevicesLimitResponseDto>(
      {url: `/api/v2/users/${userUuid}/ban-by-devices-limit`, method: 'POST'
    },
      options);
    }

/**
 * Объединение пользователей
 * @summary Объединение пользователей
 */
export const usersControllerMerge = (
    usersMergeBodyDto: BodyType<UsersMergeBodyDto>,
 options?: SecondParameter<typeof customInstance<UsersMergeResponseDto>>,) => {
      return customInstance<UsersMergeResponseDto>(
      {url: `/api/v2/users/merge`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: usersMergeBodyDto
    },
      options);
    }

/**
 * Перевод оплаченного периода
 * @summary Перевод оплаченного периода
 */
export const usersControllerTransfer = (
    usersTransferBodyDto: BodyType<UsersTransferBodyDto>,
 options?: SecondParameter<typeof customInstance<UsersTransferResponseDto>>,) => {
      return customInstance<UsersTransferResponseDto>(
      {url: `/api/v2/users/transfer`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: usersTransferBodyDto
    },
      options);
    }

/**
 * Список платежей
 * @summary Список платежей
 */
export const paymentsControllerList = (
    params?: PaymentsControllerListParams,
 options?: SecondParameter<typeof customInstance<PaymentsListResponseDto>>,) => {
      return customInstance<PaymentsListResponseDto>(
      {url: `/api/v2/payments`, method: 'GET',
        params
    },
      options);
    }

/**
 * Список платежей
 * @summary Список платежей
 */
export const remnaControllerNetworkMap = (

 options?: SecondParameter<typeof customInstance<unknown>>,) => {
      return customInstance<unknown>(
      {url: `/api/v2/remna/network-map`, method: 'GET'
    },
      options);
    }

/**
 * Список подписчиков
 * @summary Список подписчиков
 */
export const subscribersControllerList = (
    params: SubscribersControllerListParams,
 options?: SecondParameter<typeof customInstance<SubscribersListResponseDto>>,) => {
      return customInstance<SubscribersListResponseDto>(
      {url: `/api/v2/subscribers`, method: 'GET',
        params
    },
      options);
    }

/**
 * Ref ссылки
 * @summary Ref ссылки
 */
export const refLinksControllerList = (
    params: RefLinksControllerListParams,
 options?: SecondParameter<typeof customInstance<RefLinksListResponseDto>>,) => {
      return customInstance<RefLinksListResponseDto>(
      {url: `/api/v2/ref-links`, method: 'GET',
        params
    },
      options);
    }

/**
 * Создание Ref ссылки
 * @summary Создание Ref ссылки
 */
export const refLinksControllerCreate = (
    refLinksCreateBodyDto: BodyType<RefLinksCreateBodyDto>,
 options?: SecondParameter<typeof customInstance<RefLinksCreateResponseDto>>,) => {
      return customInstance<RefLinksCreateResponseDto>(
      {url: `/api/v2/ref-links`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: refLinksCreateBodyDto
    },
      options);
    }

/**
 * Удаление Ref ссылки
 * @summary Удаление Ref ссылки
 */
export const refLinksControllerDelete = (
    refId: number,
 options?: SecondParameter<typeof customInstance<RefLinksDeleteResponseDto>>,) => {
      return customInstance<RefLinksDeleteResponseDto>(
      {url: `/api/v2/ref-links/${refId}`, method: 'DELETE'
    },
      options);
    }

/**
 * Список промокодов
 * @summary Список промокодов
 */
export const promoCodesControllerList = (
    params?: PromoCodesControllerListParams,
 options?: SecondParameter<typeof customInstance<PromoCodesListResponseDto>>,) => {
      return customInstance<PromoCodesListResponseDto>(
      {url: `/api/v2/promo-codes`, method: 'GET',
        params
    },
      options);
    }

/**
 * Создание промокода
 * @summary Создание промокода
 */
export const promoCodesControllerCreate = (
    promoCodesCreateBodyDto: BodyType<PromoCodesCreateBodyDto>,
 options?: SecondParameter<typeof customInstance<PromoCodesCreateResponseDto>>,) => {
      return customInstance<PromoCodesCreateResponseDto>(
      {url: `/api/v2/promo-codes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: promoCodesCreateBodyDto
    },
      options);
    }

/**
 * Генерация промокода
 * @summary Генерация промокода
 */
export const promoCodesControllerGenerate = (

 options?: SecondParameter<typeof customInstance<PromoCodeGenerateResponseDto>>,) => {
      return customInstance<PromoCodeGenerateResponseDto>(
      {url: `/api/v2/promo-codes/generate`, method: 'GET'
    },
      options);
    }

/**
 * Удаление промокода
 * @summary Удаление промокода
 */
export const promoCodesControllerDelete = (
    promoCodeId: string,
 options?: SecondParameter<typeof customInstance<PromoCodeDeleteResponseDto>>,) => {
      return customInstance<PromoCodeDeleteResponseDto>(
      {url: `/api/v2/promo-codes/${promoCodeId}`, method: 'DELETE'
    },
      options);
    }

/**
 * Запрос промокода
 * @summary Запрос промокода
 */
export const promoCodesControllerGet = (
    promoCodeId: string,
 options?: SecondParameter<typeof customInstance<PromoCodeGetResponseDto>>,) => {
      return customInstance<PromoCodeGetResponseDto>(
      {url: `/api/v2/promo-codes/${promoCodeId}`, method: 'GET'
    },
      options);
    }

/**
 * Список баннеров
 * @summary Список баннеров
 */
export const bannerControllerList = (

 options?: SecondParameter<typeof customInstance<BannersListResponseDto>>,) => {
      return customInstance<BannersListResponseDto>(
      {url: `/api/v2/banners`, method: 'GET'
    },
      options);
    }


type AwaitedInput<T> = PromiseLike<T> | T;

    type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

export type AuthControllerSignInResult = NonNullable<Awaited<ReturnType<typeof authControllerSignIn>>>
export type AuthControllerCheckResult = NonNullable<Awaited<ReturnType<typeof authControllerCheck>>>
export type AuthControllerTgAuthResult = NonNullable<Awaited<ReturnType<typeof authControllerTgAuth>>>
export type AuthControllerLogoutResult = NonNullable<Awaited<ReturnType<typeof authControllerLogout>>>
export type MailingsControllerListResult = NonNullable<Awaited<ReturnType<typeof mailingsControllerList>>>
export type MailingsControllerCreateResult = NonNullable<Awaited<ReturnType<typeof mailingsControllerCreate>>>
export type MailingsControllerRecipientsResult = NonNullable<Awaited<ReturnType<typeof mailingsControllerRecipients>>>
export type MailingsControllerGetResult = NonNullable<Awaited<ReturnType<typeof mailingsControllerGet>>>
export type MailingsControllerDeleteResult = NonNullable<Awaited<ReturnType<typeof mailingsControllerDelete>>>
export type MailingsControllerSendTestMessageResult = NonNullable<Awaited<ReturnType<typeof mailingsControllerSendTestMessage>>>
export type MailingsControllerStartResult = NonNullable<Awaited<ReturnType<typeof mailingsControllerStart>>>
export type ServersBillingControllerGetListResult = NonNullable<Awaited<ReturnType<typeof serversBillingControllerGetList>>>
export type SupportControllerHistoryResult = NonNullable<Awaited<ReturnType<typeof supportControllerHistory>>>
export type SupportControllerInfoResult = NonNullable<Awaited<ReturnType<typeof supportControllerInfo>>>
export type SupportControllerGetPhotoResult = NonNullable<Awaited<ReturnType<typeof supportControllerGetPhoto>>>
export type SupportControllerChatsResult = NonNullable<Awaited<ReturnType<typeof supportControllerChats>>>
export type SupportControllerAnswerResult = NonNullable<Awaited<ReturnType<typeof supportControllerAnswer>>>
export type SupportControllerCloseConversationResult = NonNullable<Awaited<ReturnType<typeof supportControllerCloseConversation>>>
export type SupportControllerSearchResult = NonNullable<Awaited<ReturnType<typeof supportControllerSearch>>>
export type StatsControllerBaseStatsResult = NonNullable<Awaited<ReturnType<typeof statsControllerBaseStats>>>
export type StatsControllerSubscriptionsStatsResult = NonNullable<Awaited<ReturnType<typeof statsControllerSubscriptionsStats>>>
export type StatsControllerChartPaymentsByHoursResult = NonNullable<Awaited<ReturnType<typeof statsControllerChartPaymentsByHours>>>
export type StatsControllerChartDataResult = NonNullable<Awaited<ReturnType<typeof statsControllerChartData>>>
export type StatsControllerChartDailyDataResult = NonNullable<Awaited<ReturnType<typeof statsControllerChartDailyData>>>
export type StatsControllerSupportResult = NonNullable<Awaited<ReturnType<typeof statsControllerSupport>>>
export type StatsControllerReferralsResult = NonNullable<Awaited<ReturnType<typeof statsControllerReferrals>>>
export type UsersControllerListResult = NonNullable<Awaited<ReturnType<typeof usersControllerList>>>
export type UsersControllerUpdateSubscriptionResult = NonNullable<Awaited<ReturnType<typeof usersControllerUpdateSubscription>>>
export type UsersControllerRenewSubscriptionUrlResult = NonNullable<Awaited<ReturnType<typeof usersControllerRenewSubscriptionUrl>>>
export type UsersControllerUserGetResult = NonNullable<Awaited<ReturnType<typeof usersControllerUserGet>>>
export type UsersControllerDeleteUserResult = NonNullable<Awaited<ReturnType<typeof usersControllerDeleteUser>>>
export type UsersControllerBanSupportChatResult = NonNullable<Awaited<ReturnType<typeof usersControllerBanSupportChat>>>
export type UsersControllerUnbanSupportChatResult = NonNullable<Awaited<ReturnType<typeof usersControllerUnbanSupportChat>>>
export type UsersControllerDirectMessageResult = NonNullable<Awaited<ReturnType<typeof usersControllerDirectMessage>>>
export type UsersControllerBanByDevicesLimitResult = NonNullable<Awaited<ReturnType<typeof usersControllerBanByDevicesLimit>>>
export type UsersControllerMergeResult = NonNullable<Awaited<ReturnType<typeof usersControllerMerge>>>
export type UsersControllerTransferResult = NonNullable<Awaited<ReturnType<typeof usersControllerTransfer>>>
export type PaymentsControllerListResult = NonNullable<Awaited<ReturnType<typeof paymentsControllerList>>>
export type RemnaControllerNetworkMapResult = NonNullable<Awaited<ReturnType<typeof remnaControllerNetworkMap>>>
export type SubscribersControllerListResult = NonNullable<Awaited<ReturnType<typeof subscribersControllerList>>>
export type RefLinksControllerListResult = NonNullable<Awaited<ReturnType<typeof refLinksControllerList>>>
export type RefLinksControllerCreateResult = NonNullable<Awaited<ReturnType<typeof refLinksControllerCreate>>>
export type RefLinksControllerDeleteResult = NonNullable<Awaited<ReturnType<typeof refLinksControllerDelete>>>
export type PromoCodesControllerListResult = NonNullable<Awaited<ReturnType<typeof promoCodesControllerList>>>
export type PromoCodesControllerCreateResult = NonNullable<Awaited<ReturnType<typeof promoCodesControllerCreate>>>
export type PromoCodesControllerGenerateResult = NonNullable<Awaited<ReturnType<typeof promoCodesControllerGenerate>>>
export type PromoCodesControllerDeleteResult = NonNullable<Awaited<ReturnType<typeof promoCodesControllerDelete>>>
export type PromoCodesControllerGetResult = NonNullable<Awaited<ReturnType<typeof promoCodesControllerGet>>>
export type BannerControllerListResult = NonNullable<Awaited<ReturnType<typeof bannerControllerList>>>
